export default "__VITE_ASSET__DWzwC$IZ__"